import React from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import { useCart } from "../../components/CartContext";

import "./css/CartScreen.css";


function CartScreen() {

  const navigate = useNavigate();

  const {
    restaurantId,
    tableId,
  } = useParams();


  const {
    cart,
    cartCount,
    cartTotal,
    increaseQuantity,
    decreaseQuantity,
    removeFromCart,
    clearCart,
  } = useCart();


  // =====================================================
  // HOME PATH
  // =====================================================

  const homePath =
    `/${restaurantId}/table/${tableId}`;


  // =====================================================
  // BACK TO MENU
  // =====================================================

  const handleBackToMenu = () => {

    navigate(homePath);

  };


  // =====================================================
  // CHECKOUT
  // =====================================================

  const handleContinue = () => {

    if (!cart || cart.length === 0) {
      return;
    }

    navigate(
      `${homePath}/checkout`
    );

  };


  // =====================================================
  // FORMAT PRICE
  // =====================================================

  const formatPrice = (price) => {

    return Number(
      price || 0
    ).toFixed(2);

  };


  // =====================================================
  // EMPTY CART
  // =====================================================

  if (
    !cart ||
    cart.length === 0
  ) {

    return (

      <main className="t7-cart-page">

        <div className="t7-cart-empty">

          <div className="t7-cart-empty-number">
            01
          </div>


          <div className="t7-cart-empty-icon">
            🛒
          </div>


          <span className="t7-cart-label">
            YOUR ORDER
          </span>


          <h1>
            Your cart is empty
          </h1>


          <p>
            Discover our menu and add
            something delicious to your order.
          </p>


          <button
            type="button"
            className="t7-cart-primary-button"
            onClick={
              handleBackToMenu
            }
          >

            Explore Our Menu

            <span>
              →
            </span>

          </button>

        </div>

      </main>

    );

  }


  return (

    <main className="t7-cart-page">


      {/* =================================================
          PAGE HEADER
      ================================================= */}

      <section className="t7-cart-header">

        <div className="t7-cart-container">

          <button
            type="button"
            className="t7-cart-back-button"
            onClick={
              handleBackToMenu
            }
          >

            <span>
              ←
            </span>

            Back to Menu

          </button>


          <div className="t7-cart-title-row">

            <div>

              <span className="t7-cart-label">
                YOUR ORDER
              </span>


              <h1>
                Your Cart
              </h1>

            </div>


            <div className="t7-cart-table">

              <span>
                TABLE
              </span>

              <strong>
                {tableId}
              </strong>

            </div>

          </div>

        </div>

      </section>



      {/* =================================================
          CART CONTENT
      ================================================= */}

      <section className="t7-cart-content">

        <div className="t7-cart-container">

          <div className="t7-cart-layout">


            {/* =================================================
                LEFT SIDE
            ================================================= */}

            <div className="t7-cart-items-section">


              <div className="t7-cart-items-heading">

                <div>

                  <span>
                    {cartCount}
                  </span>

                  <h2>
                    Items in your order
                  </h2>

                </div>


                <button
                  type="button"
                  className="t7-clear-cart"
                  onClick={
                    clearCart
                  }
                >
                  Clear all
                </button>

              </div>



              {/* =================================================
                  CART ITEMS
              ================================================= */}

              <div className="t7-cart-items">

                {cart.map(
                  (item) => (

                    <article
                      className="t7-cart-item"
                      key={item.id}
                    >


                      {/* IMAGE */}

                      <div className="t7-cart-item-image">

                        {item.image ? (

                          <img
                            src={item.image}
                            alt={item.name}
                          />

                        ) : (

                          <div className="t7-cart-image-placeholder">
                            ✦
                          </div>

                        )}

                      </div>



                      {/* ITEM DETAILS */}

                      <div className="t7-cart-item-details">

                        <span className="t7-cart-item-category">
                          {item.categoryName ||
                            "SPICE & SAFFRON"}
                        </span>


                        <h3>
                          {item.name}
                        </h3>


                        {item.description && (

                          <p>
                            {item.description}
                          </p>

                        )}


                        <div className="t7-cart-item-price">

                          ₹
                          {formatPrice(
                            item.price
                          )}

                        </div>

                      </div>



                      {/* QUANTITY */}

                      <div className="t7-cart-item-actions">

                        <div className="t7-quantity-control">

                          <button
                            type="button"
                            onClick={() =>
                              decreaseQuantity(
                                item.id
                              )
                            }
                            aria-label={`Decrease ${item.name}`}
                          >
                            −
                          </button>


                          <span>
                            {item.quantity}
                          </span>


                          <button
                            type="button"
                            onClick={() =>
                              increaseQuantity(
                                item.id
                              )
                            }
                            aria-label={`Increase ${item.name}`}
                          >
                            +
                          </button>

                        </div>


                        <strong className="t7-cart-item-total">

                          ₹
                          {formatPrice(
                            Number(item.price) *
                            Number(item.quantity)
                          )}

                        </strong>


                        <button
                          type="button"
                          className="t7-remove-item"
                          onClick={() =>
                            removeFromCart(
                              item.id
                            )
                          }
                        >

                          Remove

                        </button>

                      </div>

                    </article>

                  )
                )}

              </div>

            </div>



            {/* =================================================
                ORDER SUMMARY
            ================================================= */}

            <aside className="t7-cart-summary">

              <div className="t7-summary-number">
                02
              </div>


              <span className="t7-cart-label">
                ORDER SUMMARY
              </span>


              <h2>
                Your order
              </h2>


              <div className="t7-summary-items">

                {cart.map(
                  (item) => (

                    <div
                      className="t7-summary-item"
                      key={item.id}
                    >

                      <div>

                        <span>
                          {item.quantity}
                          {" × "}
                          {item.name}
                        </span>

                      </div>


                      <strong>

                        ₹
                        {formatPrice(
                          Number(item.price) *
                          Number(item.quantity)
                        )}

                      </strong>

                    </div>

                  )
                )}

              </div>


              <div className="t7-summary-divider"></div>


              <div className="t7-summary-row">

                <span>
                  Subtotal
                </span>

                <strong>
                  ₹
                  {formatPrice(
                    cartTotal
                  )}
                </strong>

              </div>


              <p className="t7-summary-note">

                Taxes and service charges
                will be calculated at checkout.

              </p>


              <button
                type="button"
                className="t7-checkout-button"
                onClick={
                  handleContinue
                }
              >

                Continue to Checkout

                <span>
                  →
                </span>

              </button>


              <button
                type="button"
                className="t7-summary-menu-button"
                onClick={
                  handleBackToMenu
                }
              >

                ← Add More Items

              </button>

            </aside>

          </div>

        </div>

      </section>



      {/* =================================================
          BOTTOM NOTE
      ================================================= */}

      <section className="t7-cart-note">

        <div className="t7-cart-container">

          <span>
            ✦
          </span>

          <p>
            Freshly prepared with authentic
            Indian flavours, just for your table.
          </p>

        </div>

      </section>

    </main>

  );

}


export default CartScreen;